import axios from "axios";

// ---------------------------------------------------------------------------
// authApi — instance axios MENTAH khusus endpoint autentikasi PUBLIK
// (login/register/reset/verify) yang TIDAK memerlukan token.
//
// Sengaja TANPA interceptor:
//  - tidak menyuntik header Authorization
//  - tidak memicu logic refresh-token saat menerima 401
// sehingga request ke endpoint auth tidak pernah memicu loop refresh/reload.
// ---------------------------------------------------------------------------
const baseUrl = process.env.REACT_APP_BASE_URL;

const authApi = axios.create({
    baseURL: baseUrl,
    withCredentials: true, // cookie tetap terkirim bila diperlukan
});

export default authApi;
